import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import '../Pagination.css';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import * as studentsService from '../../services/students/studentsService';
import { classifyStudentsError } from '../../services/students/studentsDto';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
  buildStandardRowActions,
  MdRowActions,
  MdTableActionsCell,
  MdTableCell,
} from '../common/MdRowActions';
import { PlusIcon, SearchIcon, UploadIcon } from '../common/mdPageIcons';

export class MDAlumnos extends Component {
  static displayName = MDAlumnos.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      searchInput: '',
      totalCount: 0,
      perPage: 10,
      paginationData: [],
      pageCount: 0,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
      successMessage: '',
      deletingId: null,
      pendingDelete: null,
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => studentsService.listStudents(query),
      defaultPageSize: 10,
      onChange: (gridState) => this.applyGridState(gridState),
    });
    this.searchInputRef = React.createRef();
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      totalCount: gridState.totalCount,
      searchInput: gridState.search,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage,
    });
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWAlumnos');
    if (canAccess) {
      this.populateData();
    }
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handleStudentsError(error));
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
    if (cleared && this.grid.getState().search.trim() !== '') {
      this.grid.clearSearchIfNeeded(this.grid.getState().search).catch((error) => this.handleStudentsError(error));
    }
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.grid.submitSearch(search).catch((error) => this.handleStudentsError(error));
  };

  handleRemoveItem = (alumno) => {
    if (this.state.deletingId) {
      return;
    }
    this.setState({
      pendingDelete: {
        id: alumno.alumnoCodigo,
        dni: alumno.alumnoDni,
        nombre: alumno.alumnoNombre,
      },
    });
  };

  handleCancelDelete = () => {
    if (this.state.deletingId) {
      return;
    }
    this.setState({ pendingDelete: null });
  };

  handleConfirmDelete = () => {
    const { pendingDelete } = this.state;
    if (!pendingDelete || this.state.deletingId) {
      return;
    }
    this.deleteItem(pendingDelete.id);
  };

  renderAlumnosTable(alumnos) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table md-page__table--actions-fixed" aria-labelledby="md-alumnos-title">
          <thead>
            <tr>
              <th scope="col" className="md-page__table__col-dni">DNI</th>
              <th scope="col">Nombre y Apellido</th>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acciones" />
            </tr>
          </thead>
          <tbody>
            {alumnos.map((alumno) => (
              <tr key={alumno.alumnoCodigo}>
                <MdTableCell className="md-page__table__col-dni">{alumno.alumnoDni}</MdTableCell>
                <MdTableCell>{alumno.alumnoNombre}</MdTableCell>
                <MdTableActionsCell>
                  <MdRowActions
                    items={buildStandardRowActions({
                      editTo: '/update-alumno/' + alumno.alumnoCodigo + '/0',
                      onDelete: () => this.handleRemoveItem(alumno),
                      deleteDisabled: this.state.loading || this.state.deletingId === alumno.alumnoCodigo,
                      deleteLabel: this.state.deletingId === alumno.alumnoCodigo ? 'Eliminando...' : 'Borrar',
                      detailTo: '/update-alumno/' + alumno.alumnoCodigo + '/1',
                    })}
                  />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading;
    const listLoading = this.state.loading && !this.state.deletingId;
    const { pendingDelete } = this.state;

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderAlumnosTable(this.state.paginationData);

    return (
      <div className="md-page md-alumnos">
        <div className="md-page__header">
          <h1 id="md-alumnos-title" className="md-page__title">Manejar Datos de Alumnos</h1>
        </div>

        {!this.state.showErrorMessage ? (
          <div className="md-page__toolbar">
            <Link className="md-page__action-link" to="/add-alumno">
              <PlusIcon />
              Nuevo Alumno
            </Link>
            <Link className="md-page__action-link" to="/iap">
              <UploadIcon />
              Inscripción masiva
            </Link>
          </div>
        ) : null}

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {this.state.errorMessage}
            </div>
          ) : null}
          {this.state.successMessage ? (
            <div className="md-page__success">{this.state.successMessage}</div>
          ) : null}
        </div>

        {!this.state.showErrorMessage ? (
          <>
            <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
              <div className="md-page__search-wrap">
                <span className="md-page__search-icon">
                  <SearchIcon />
                </span>
                <input
                  ref={this.searchInputRef}
                  className="md-page__search-input"
                  type="text"
                  name="search"
                  autoComplete="off"
                  disabled={isBusy}
                  placeholder="Ingrese DNI o Apellido del alumno"
                  value={this.state.searchInput}
                  onChange={this.handleSearchInputChange}
                />
              </div>
              <button type="submit" className="md-page__search-btn" disabled={isBusy}>
                Buscar
              </button>
            </form>

            {contents}

            {!listLoading && this.state.pageCount > 1 ? (
              <div className="md-page__pagination">
                <ReactPaginate
                  previousLabel="Anterior"
                  nextLabel="Siguiente"
                  breakLabel="..."
                  breakClassName="break-me"
                  pageCount={this.state.pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  forcePage={this.state.forcePage}
                  containerClassName="pagination"
                  subContainerClassName="pages pagination"
                  activeClassName="active"
                />
              </div>
            ) : null}
          </>
        ) : null}

        <ConfirmDialog
          open={Boolean(pendingDelete)}
          title="Eliminar alumno"
          message="Esta acción eliminará al alumno del sistema y no se puede deshacer."
          detail={
            pendingDelete
              ? `${pendingDelete.nombre} — DNI ${pendingDelete.dni}`
              : ''
          }
          confirmLabel="Eliminar"
          cancelLabel="Cancelar"
          variant="danger"
          loading={Boolean(this.state.deletingId)}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />
      </div>
    );
  }

  handleStudentsError(error) {
    const outcome = classifyStudentsError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false,
    });
  }

  async populateData() {
    try {
      await this.grid.load();
    } catch (error) {
      this.handleStudentsError(error);
    }
  }

  async deleteItem(id) {
    this.setState({ deletingId: id, showErrorMessage: false, errorMessage: '' });
    try {
      await studentsService.deleteStudent(id);
      this.setState({ successMessage: 'El alumno se eliminó correctamente.', pendingDelete: null });
      await this.grid.reloadAfterDelete(this.state.paginationData.length);
    } catch (error) {
      this.handleStudentsError(error);
    } finally {
      this.setState({ deletingId: null });
    }
  }
}
